import type { CountDataParams, CountName } from "../types"
import { getWorkkeysReplaceTerm } from "../helpers/workkeysReplaceTerms"

export const COUNT_PARAMS: Record<CountName, CountDataParams> = {
  Districts: {
    label: "Districts",
    icon: "city"
  },
  Schools: {
    label: getWorkkeysReplaceTerm("schools", true),
    icon: "school"
  },
  ActiveStudents: {
    label: `Active ${getWorkkeysReplaceTerm("students", true)}`,
    icon: "users"
  },
  Teachers: {
    label: getWorkkeysReplaceTerm("teachers", true),
    icon: "chalkboard-teacher"
  },
  DistrictAdmins: {
    label: "District Admins",
    icon: "city"
  },
  Students: {
    label: getWorkkeysReplaceTerm("students", true),
    icon: "users"
  },
  SchoolAdmins: {
    label: `${getWorkkeysReplaceTerm("school", true)} Admins`,
    icon: "school"
  },
  Classes: {
    label: "Classes",
    icon: "users-class"
  },
  ApproxDuration: {
    label: "Approx. Duration",
    icon: "clock",
    format: "duration"
  },
  InteractionsCount: {
    label: "Interactions",
    icon: "hand-pointer"
  },
  QuestionsCount: {
    label: "Questions",
    icon: "check-circle"
  },
  PracticeQuestionsCount: {
    label: "Practice Questions",
    icon: "check-circle"
  }
}

export const COUNTS_BY_VIEW: Record<string, Record<string, CountName[]>> = {
  organization: {
    organizations_id: [],
    states_id: ["Districts", "Schools", "ActiveStudents"],
    districts_id: ["Schools", "Teachers", "ActiveStudents", "DistrictAdmins"],
    schools_id: ["Teachers", "Students", "ActiveStudents", "SchoolAdmins"],
    teachers_id: ["Classes", "Students", "ActiveStudents"]
  },
  content: {
    "content-library/element_id": ["ApproxDuration", "QuestionsCount"],
    "content-library/study-hall_id": [
      "ApproxDuration",
      "PracticeQuestionsCount"
    ],
    "content-library/practice-test_id": ["QuestionsCount"],
    "content-library/mastery-lesson_id": [
      "ApproxDuration",
      "InteractionsCount",
      "PracticeQuestionsCount"
    ],
    "content-library/mastery-curriculum_id": [
      "ApproxDuration",
      "QuestionsCount"
    ]
  }
}
